export enum SensitiveActions {
  setSensitiveData = '[SESSION]:SET_SENSITIVE_DATA',
}
